import type { ReactNode } from "react";

export interface OverviewField {
  label: string;
  value: ReactNode;
  /** Span both columns — for long text like descriptions/notes. */
  full?: boolean;
}

interface OverviewFieldListProps {
  fields: OverviewField[];
}

// Read-only label/value grid for entity overview screens — the view-mode
// counterpart to the `.form-grid`/`.field` inputs used in the edit popups.
export const OverviewFieldList = ({ fields }: OverviewFieldListProps) => (
  <div className="ovf-list">
    {(fields ?? []).map((f, index) => (
      // Index-suffixed because labels are not guaranteed unique — two "Notes"
      // rows would otherwise collide on the key and React would reuse the
      // wrong node. The list is static per render, so the index is stable.
      <div key={`${f.label}-${index}`} className={`ovf-list__item${f.full ? " ovf-list__item--full" : ""}`}>
        <span className="ovf-list__label">{f.label}</span>
        <span className="ovf-list__value">{f.value ?? "—"}</span>
      </div>
    ))}
  </div>
);
